// extracted by mini-css-extract-plugin
export default {"paper":"paper__paper","paperTitleWrapper":"paper__paperTitleWrapper","paperTitle":"paper__paperTitle","flex":"paper__flex","content":"paper__content"};